import BaseApi from '../BaseApi';
import { TransactionApiConverter } from './TransactionApiConverter';

class TransactionApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin`;
    this.converter = new TransactionApiConverter();
  }

  createUser = (userName, password, currency) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/create_user`, {
      email: userName,
      password,
      name: '',
      currency,
    });

  getTransactions = period =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/transfers`,
      {
        from_date: period.startDate,
        to_date: period.endDate,
      },
      null,
      this.converter.convertTransfers,
    );

  getActiveRequests = data =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/cashier_withdrawal`,
      data,
      null,
      this.converter.convertActiveRequests,
    );

  setRequestStatus = ({ id, status, comment }) =>
    this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/cashier_withdrawal`, { id, status, comment });

}

export default TransactionApi;
